
import { defineComponent, PropType } from 'vue'
import CvSection from './CvSection.vue' // @ is an alias to /src
import { IContacts } from '@/store/cvInterfaces'

export default defineComponent({
  components: {
    CvSection,
  },
  props: {
    data: {
      type: Object as PropType<IContacts>,
      required: true,
    },
  },
})
